<template>
    <div class="course_wrap">
        <div class="top flex-between">
            <div class="left_bar">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item><i class="iconfont icon-kechengliebiao">&nbsp;课程列表</i></el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="back_course" v-if="isCourseDetail" @click="isCourseDetail = false,getCourseList">
                <i class="iconfont icon-arrowLeft">&nbsp;返回</i>
            </div>
        </div>
        <div class="course_content" v-if="!isCourseDetail">
            <!-- 课程筛选 -->
            <div class="flex-between search_bar">
                <div>
                    <i class="iconfont icon-kejian">&nbsp; 所有课程资源</i>
                </div>
                <div class="flex-start-center search_wrap">
                    <el-input v-model="searchKey" @keyup.enter.native='pages.currentPage = 1,getCourseList()' placeholder="请输入课程关键字"></el-input>
                    <el-button type="primary" @click="pages.currentPage = 1,getCourseList()"><i class="el-icon-search"></i></el-button>
                </div>
                <!-- <div class="flex-start-center search_wrap">
                    <i class="iconfont icon-sousuo">&nbsp; 搜索课程：</i>
                    <el-input v-model="searchKey"  placeholder="输入课程关键字"></el-input>
                </div> -->
            </div>
            <!-- 课程列表为空 -->
            <div class="empty-wrap" v-if="courseListMenu.length == 0">
                <img src="../../assets/img/offshelf.png" alt="">
            </div>
            <!-- 课程列表 -->
            <div class="course_list flex-start">
                <div @click="getCourseDetail(item)" class="course_item button-hover" v-for="item in courseListMenu" :key="item.id">
                    <div class="course_title">{{item.name}}</div>
                    <div class="course_text ">课件描述：{{item.description}}</div>
                    <div class="course_teacher">教师：{{item.teacherName}}</div>
                    <div class="course_date">课程公开时间：{{item.createTime}}</div>
                </div>
            </div>
            <!-- 分页 -->
            <div class="flex-around" v-if="pages.totals > 6">
                <el-pagination  background :page-size="6" layout="prev, pager, next"  @current-change="getCourseList" :current-page.sync="pages.currentPage" :total="pages.totals"></el-pagination>
            </div>
        </div>
        <div class="course_content" v-else>
            <div class="course_info">
                <i class="iconfont icon-xueyuan-mulu">&nbsp;{{courseName}}</i>
                <div class="course_brief">课程简介：{{courseBrief}}</div>
            </div>
            <div class="empty-wrap" v-if="courseMenu.length == 0">
                <img src="../../assets/img/offshelf.png" alt="">
            </div>
            <div class="course_menu_content" v-else>
                <div v-for="(menu,i) in courseMenu" :key="menu.id">
                    <div class="menu_title">{{i + 1}} {{menu.name}}</div>
                    <div class="sub_menu_list">
                        <div class="sub_menu_content" v-for="(subMenu,j) in menu.children" :key="subMenu.id">
                            <div class="sub_menu_title" >
                                {{ i + 1 }}.{{ j + 1 }} {{ subMenu.name }}
                            </div>
                            <div class="file_list flex-start">
                                <div class="sub_menu_file button-hover" v-for="file in subMenu.children" :key="file.id">
                                    <div class='file_top'>
                                        <div class='file_name'>{{ file.name }}</div>
                                        <div class='file_type'>
                                            {{ file.name.includes('docx') || file.name.includes('pptx') || file.name.includes('pdf') || file.name.includes('xlsx')
                                            ? '文档'
                                            : file.name.includes('.ipynb')
                                                ? '代码' : '文件' }}
                                        </div>
                                    </div>
                                    <div class='file_bottom' @click='downloadFile(file.fileUrl) '>
                                        <i class='iconfont icon-yanjing' v-if="
                                        file.name.includes('.png')
                                        || file.name.includes('.jpg')
                                        || file.name.includes('.ipynb')
                                        || file.name.includes('.pdf')
                                        ">&nbsp;&nbsp;预览</i>
                                        <i class='iconfont icon-xiazai' v-else>&nbsp;&nbsp;下载</i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { courseDetail, courseList } from '../../utils/api';

export default {
    data() {
        return {
            searchKey: '',
            isCourseDetail: false,
            courseName: '机器学习算法课件',
            courseBrief: '关于机器学习算法的课程，包含分类课程、集成分类模型、回归模型与无监督模型。',
            courseMenu: [{
                id: 0,
                title: '机器学习算法1',
                subMenu: [{
                        menuId:0,
                        subTitle:'机器学习算法1.1',
                        fileList:[{
                            fileId:0,
                            fileName:'机器学习算法简介.docx'
                        },{
                            fileId:1,
                            fileName:'机器学习算法简介.docx'
                        },{
                            fileId:2,
                            fileName:'机器学习算法简介.docx'
                        },{
                            fileId:3,
                            fileName:'机器学习算法简介.docx'
                        }],
                    },{
                        menuId:1,
                        subTitle:'机器学习算法1.2',
                        fileList:[{
                            fileId:0,
                            fileName:'机器学习算法简介.docx'
                        },{
                            fileId:1,
                            fileName:'机器学习算法简介.docx'
                        },{
                            fileId:2,
                            fileName:'机器学习算法简介.docx'
                        },{
                            fileId:3,
                            fileName:'机器学习算法简介.docx'
                        },{
                            fileId:4,
                            fileName:'机器学习算法简介.docx'
                        },{
                            fileId:5,
                            fileName:'机器学习算法简介.docx'
                        },],
                    }]
                }],
                pages:{
                    currentPage:1,
                    totals:1
                },
                courseListMenu:[]
            }
        },
        created(){
            // let url = document.location.href;
        },
        mounted(){

        },
        methods: {
            //下载课程文件
            downloadFile(fileUrl){
                window.open(fileUrl,'_blank')
                // location.href = fileUrl
            },

            //获取课程细节
            getCourseDetail(course){
                this.courseName = course.name
                this.courseBrief = course.description
                courseDetail(course.id).then(res => {
                    this.courseMenu = res.data
                }).catch(err => {})
                this.isCourseDetail = true
            },

            //获取课程列表
            getCourseList(){
                let params = {
                    keyword:this.searchKey,
                    page:this.pages.currentPage,
                    size:6
                }
                courseList(params).then(res => {
                    this.courseListMenu = res.data.list
                }).catch(err => {})
            }
        }
    }
</script>

<style lang="scss" scoped>
// 课程内容列表
.course_info{
    color: #001E84;
    line-height: 1.6;
    i{
        font-size: 20px;
        font-weight: bold;
    }
    .course_brief{
        margin: 10px 0px;
        font-size: 18px;
    }
}
.course_menu_content{
    margin-top: 10px;
    font-weight: bold;
    color: #001E84;
    margin-top: 30px;
    .menu_title{
        font-size: 18px;
    }
    .sub_menu_list{

        box-sizing: border-box;
        padding: 0px 20px;
        .sub_menu_content{
            .sub_menu_title{
                font-size: 18px;
                margin: 20px 0px;
            }
            .file_list{
                flex-wrap: wrap;
                box-sizing: border-box;
                .sub_menu_file{
                    box-sizing: border-box;
                    width: 23%;
                    margin: 15px 1%;
                    border-radius: 2px;
                    box-shadow: 0px 3px 6px #BDC8F5;
                    .file_top{
                        padding: 20px 24px;
                        box-sizing: border-box;
                        .file_name{
                            line-height: 1.7;
                            font-size: 18px;
                            font-weight: 500;
                            height: 65px;
                            overflow: hidden;
                        }
                        .file_type{
                            width: 60px;
                            height: 25px;
                            line-height: 25px;
                            color: #666;
                            font-size: 16px;
                            font-weight: 300;
                            text-align: center;
                            background: #F5F5F5;
                        }
                    }
                    .file_bottom{
                        width: 100%;
                        height: 46px;
                        line-height: 46px;
                        background: rgba(229, 235, 253, 0.39);
                        color: #001E84;
                        text-align: center;
                    }

                }
                .sub_menu_file:hover{
                    .file_bottom{
                        color:white;
                        background: #5277F7;
                    }
                }
            }
        }
    }
}
// 课程列表
.course_wrap{
    padding-bottom: 50px;
}
.course_list{
    margin: 20px 0px;
    flex-wrap: wrap;
    .course_item{
        padding: 30px 35px;
        width: 32%;
        margin: 10px 0.5%;
        background: rgba(255, 255, 255, 0.39);
        box-shadow: 0px 3px 6px #BDC8F5;
        border-radius: 2px;
        color: #001E84;
        box-sizing: border-box;
        font-size: 18px;
        .course_title{
            line-height: 1.7;
            font-size: 20px;
            font-weight: bold;
        }
        .course_text{
            height: 90px;
            height: 90px;
            margin: 5px 0px;
            overflow: hidden;
            line-height: 1.6;
            text-align: justify;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;//当属性值为3，表示超出3行隐藏
        }
        .course_teacher{
            margin: 10px 0px;
        }
        .course_date{
            color: #999;
        }
    }
    .course_item:hover{
        border: 2px solid #5973E2;
        font-weight: 400;
    }
}
.search_bar{
    .search_wrap{
        i{
            opacity: 0.8;
            color: white;
            font-size: 14px;
        }
    }
    i{
        font-size: 18px;
        font-weight: bold;
        color: #001E84;
    }
}
.course_content{
    box-sizing: border-box;
    background: white;
    padding: 20px 80px;
    margin: 10px 0px;
}
.top{
    height: 55px;
    box-sizing: border-box;
    background: white;
    box-sizing: border-box;
    margin-top: 15px;
    padding: 0px 50px 0px 0px;
    color: #848484;
    .icon-shoucangjia,.icon-xianxingwenjianjia{
        margin-right: 5px;
        font-size: 18px;
    }
    .icon-arrowLeft:hover{
            color: #5277F7;
        }
    .icon-xianxingwenjianjia:hover{
        color: #FEA757;
    }
    .left_bar{
        min-width: 100px;
        // max-width: 250px;
        /deep/.el-breadcrumb__inner{
            line-height: 55px;
            font-size: 17px;
            color: white;
        }
        .icon-shoucangjia{
            color: white;
        }
        height: 55px;
        padding: 0px 50px;
        background: url(../../assets/img/collectBar.png) 0 0/100% 100% no-repeat;
    }
}
</style>

